export default __webpack_public_path__ + "static/media/RTR1802V_Posterior.74ae8dc7.webp";